const encode = (str) => {
    var encode = encodeURI(str);
    var base64 = btoa(encode);
    return base64;
}

const handleDownloadUri = (title,  uri)  => {
    let ext = uri.substring(uri.lastIndexOf('.') + 1);
    title = title+'.'+ext
    if (uri.indexOf("https://") < 0) {
        uri = uri.replace("http://", "https://");
    }
    let elt = document.createElement('a');
    elt.setAttribute('href', uri+'?download_name='+title);
    elt.setAttribute('download', title);
    // elt.setAttribute('target', '_bank');
    elt.style.display = 'none';
    document.body.appendChild(elt);
    elt.click();
    document.body.removeChild(elt);
}

const isElementNotInViewport = function(el) {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
        rect.bottom <= 0
    );
};
export default
{
    encode,
    handleDownloadUri,
    isElementNotInViewport
}